import { adminRoutes } from '../../lib/adminRoutes';
import Component from '../../Components/Sidebar_Component';
import withAuth from '../../Components/withAuth';

const Vendor = ({ vendor }) => {

    return (
        <>
            <main className='my-8'>
                <div dir="rtl">
                    <div className="container">
                        <Component page='admin' query={vendor} links={adminRoutes} />
                    </div>
                </div>
            </main>
        </>
    );
};

export default withAuth(Vendor);